export default "__VITE_ASSET__BxZ_RplB__"